import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('data', 'countries');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'countries',
  type: 'get',
  slug: [],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/data/countries.js